export const getRefreshUrl = () => window.location !== window.parent.location ? document.referrer : document.location.href;